var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.propVal===_vm.value},on:{"change":_vm.emitVal}}),_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }